import Vue from 'vue'
import UIIntro from './Intro.vue'
import UIShare from './share.vue'
import UITips from './Tips.vue'
import UIMessage from './Message.vue'


const Intro = Vue.extend(UIIntro)
const Share = Vue.extend(UIShare)
const Tips = Vue.extend(UITips)
const Message = Vue.extend(UIMessage)

export function $message(data={}) {
    let instance = new Message({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $tips(data={}) {
    let instance = new Tips({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}



export function $intro(data={}) {
    let instance = new Intro({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}


export function $share(data={}) {
    let instance = new Share({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}


